import { css } from '@emotion/core'

export const confirmationOverlay = css`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.8);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2000;
`

export const successModal = css`
  background-color: #2d2d2d;
  border-radius: 12px;
  padding: 16px;
  margin: 20px;
  max-width: 280px;
  width: 100%;
  text-align: center;
`

export const successHeader = css`
  margin-bottom: 12px;
`

export const successTitle = css`
  color: #ffffff;
`

export const successContent = css`
  margin-bottom: 16px;
`

export const successMessage = css`
  color: #cccccc;
  line-height: 1.4;
`

export const successActions = css`
  display: flex;
  justify-content: center;
`

export const successButton = css`
  background: #6DB66D !important;
  background-color: #6DB66D !important;
  border: none;
  border-radius: 20px;
  padding: 10px 24px;
  min-height: 40px;
  font-size: 13px;
  font-weight: bold;
  cursor: pointer;
  box-shadow: none;
  
  &:hover {
    background: #5FA65F !important;
    background-color: #5FA65F !important;
  }
`

export const successButtonText = css`
  color: #000000;
`

export const errorModal = css`
  background-color: #2d2d2d;
  border-radius: 12px;
  padding: 16px;
  margin: 20px;
  max-width: 280px;
  width: 100%;
  text-align: center;
`

export const errorHeader = css`
  margin-bottom: 12px;
`

export const errorTitle = css`
  color: #ffffff;
`

export const errorContent = css`
  margin-bottom: 16px;
`

export const errorMessage = css`
  color: #cccccc;
  line-height: 1.4;
`

export const errorActions = css`
  display: flex;
  justify-content: center;
`

export const errorButton = css`
  background: #6DB66D !important;
  background-color: #6DB66D !important;
  border: none;
  border-radius: 20px;
  padding: 10px 24px;
  min-height: 40px;
  font-size: 13px;
  font-weight: bold;
  cursor: pointer;
  box-shadow: none;
  
  &:hover {
    background: #5FA65F !important;
    background-color: #5FA65F !important;
  }
`

export const errorButtonText = css`
  color: #000000;
`

export const topSuccessMessage = css`
  position: fixed;
  bottom: 120px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 9999;
  animation: slideUp 0.3s ease-out;
  pointer-events: none;
  
  @keyframes slideUp {
    from {
      transform: translate(-50%, 100%);
      opacity: 0;
    }
    to {
      transform: translate(-50%, 0);
      opacity: 1;
    }
  }
`

export const topSuccessContent = css`
  background-color: #4caf50;
  color: white;
  padding: 8px 14px;
  border-radius: 16px;
  display: flex;
  align-items: center;
  gap: 6px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
  min-width: 140px;
  justify-content: center;
`

export const topSuccessIcon = css`
  font-size: 12px;
  font-weight: bold;
  color: white;
  background-color: rgba(255, 255, 255, 0.2);
  border-radius: 50%;
  width: 14px;
  height: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 8px;
`

export const topSuccessText = css`
  color: white;
  font-weight: 500;
  font-size: 11px;
`

export const topErrorMessage = css`
  position: fixed;
  bottom: 120px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 9999;
  animation: slideUp 0.3s ease-out;
  pointer-events: none;
  
  @keyframes slideUp {
    from {
      transform: translate(-50%, 100%);
      opacity: 0;
    }
    to {
      transform: translate(-50%, 0);
      opacity: 1;
    }
  }
`

export const topErrorContent = css`
  background-color: #d32f2f;
  color: white;
  padding: 8px 14px;
  border-radius: 16px;
  display: flex;
  align-items: center;
  gap: 6px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
  min-width: 140px;
  justify-content: center;
`

export const topErrorIcon = css`
  font-size: 12px;
  font-weight: bold;
  color: white;
  background-color: rgba(255, 255, 255, 0.2);
  border-radius: 50%;
  width: 14px;
  height: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 8px;
`

export const topErrorText = css`
  color: white;
  font-weight: 500;
  font-size: 11px;
` 